<template>
  <div class="usage-summary-card">
    <div class="mb-16 flex items-center gap-4">
      <h4 class="text-neutral-text-strong text-lg font-bold">
        {{ title }}
      </h4>
      <slot name="title-action" />
    </div>
    <div :class="{ 'bg-neutral-background-weak rounded-12': isFooterDetached }">
      <BittsContainer no-padding :class="{ 'rounded-12': isFooterDetached }">
        <div class="p-24">
          <UsageMeter
            :label="label"
            :used="used"
            :limit="limit"
            :percent-text="percentText"
            :width="width"
            :color="color"
            :is-loading="isLoading"
            :is-limit-masked="isLimitMasked"
          >
            <template #sub-line>
              <slot name="sub-line" />
            </template>
            <template #action>
              <slot name="action" />
            </template>
          </UsageMeter>
          <slot name="callout" />
        </div>
        <div
          v-if="$slots.footer && !isFooterDetached"
          class="usage-summary-card__footer border-t border-neutral-border py-12 px-24 flex items-center justify-between"
        >
          <slot name="footer" />
        </div>
      </BittsContainer>
      <div
        v-if="$slots.footer && isFooterDetached"
        class="usage-summary-card__footer py-16 px-20 flex items-center justify-between"
      >
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { BittsContainer } from '@crossbeam/bitts';

import type { UsageStatusColor } from '@/composables/credits/useCreditLimits';

import UsageMeter from './UsageMeter.vue';

withDefaults(
  defineProps<{
    title: string;
    label: string;
    used: number | null;
    limit: number | null;
    percentText: string;
    width: string;
    color: UsageStatusColor;
    isLoading?: boolean;
    isLimitMasked?: boolean;
    isFooterDetached?: boolean;
  }>(),
  { isLoading: false, isLimitMasked: false, isFooterDetached: false },
);
</script>
